import React from 'react';
import { Column, Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { Icon, Button, Chip, Card, CardMedia, CardContent, CardActionArea } from '@material-ui/core';
import { HorizontalScroll } from 'global/components/horizontal-scroll';
import { useStyles } from './styles';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { isDark } from 'global/styles';
import { get, size, flatten, take } from 'global/lib/lodash';
import { percentify } from 'global/utils';
import { useSelector } from 'react-redux';
import withRouter from 'react-router-dom/withRouter';
import { useFilter } from 'global/hooks/useFilter';
import { CourseStatus } from '../../../global/lib/filter';

export const filterCoursesByStatus = (data, filters) => {
  const filt = flatten(get(filters, 'courseStatus', []));

  return data.filter((d) => {
    const { completion } = d;

    if (!size(filt)) {
      return true;
    }

    return !!size(
      filt.filter((f) => {
        const v = parseInt(f);
        if (isNaN(v) || v === 100) {
          return f == completion;
        } else {
          return completion >= v && completion !== 100;
        }
      })
    );
  });
};

const amt = 9;

export const Courses = withRouter((props) => {
  const { isReview } = props;
  const classes = useStyles();
  const filters = useSelector((state) => get(state, 'filter.library.editions', {}));
  const { changeFilter } = useFilter('library.editions');

  const data = take(filterCoursesByStatus(props.data, filters), amt);

  const onSelect = (course) => {
    const isCourse = course && course.id;
    if (isCourse) {
      props.history.push(`/courses/${isCourse}`, { fromLibrary: true, isReview });
    } else {
      props.history.push('/courses', { isReview });
    }
  };

  const finished = props.data.filter((f) => f.completion >= 100);
  const allFinished = size(finished) && size(finished) >= size(props.data);

  const _data = [
    ...data,
    allFinished && !size(data) && !isReview
      ? {
          onSelect: () =>
            changeFilter(
              'courseStatus',
              CourseStatus.map((ci) => ci.value)
            ),
          title: (
            <Row>
              <Icon style={{ marginRight: 8 }}>exclamation</Icon>
              <Text bold type="title_large">
                Congrats!
              </Text>
            </Row>
          ),
          subtitle: (
            <Column>
              <Text>Looks like you’ve finished all your courses.</Text>
              <Text>Click to view finished courses</Text>
            </Column>
          ),
        }
      : false,
    size(props.data) < amt
      ? false
      : {
          title: (
            <Row>
              <Icon style={{ marginRight: 8 }}>list</Icon>
              <Text bold type="title_large">
                Show All
              </Text>
            </Row>
          ),
          subtitle: (
            <Column>
              <Text>There's more!</Text>
              <Text>Click to see all your courses</Text>
            </Column>
          ),
        },
  ].filter((f) => !!f);

  const title = get(props, 'title', isReview ? 'Course Review' : 'Your Courses');

  return (
    <div>
      <Row className={classes.headContainer}>
        <Text type="headline_small" bold>
          {title}
        </Text>
        <Button style={{ marginLeft: 8 }} onClick={() => onSelect()} color="primary" startIcon={<Icon>list</Icon>}>
          SHOW ALL
        </Button>
      </Row>
      <HorizontalScroll>
        {_data.map((card) => (
          <PerformCard {...props} {...card} classes={classes} onSelect={card.onSelect || onSelect} />
        ))}
      </HorizontalScroll>
    </div>
  );
});

const PerformCard = (props) => {
  const { editionName, title, subtitle, classes, assessment, onSelect, isReview, user } = props;

  const compValue = (() => {
    return props.completion === null ? 0 : props.completion;
  })();

  const displayItems = isReview
    ? [{ title: 'Pending Your Review', key: 'submitted' }]
    : [
        { title: 'Review Final Comments', key: 'approved' },
        { title: 'Revisions Needed', key: 'revise' },
      ];

  const actions = (() => {
    const status = get(assessment, 'status');
    const hasAction = status && displayItems.find((item) => item.key === status);
    if (hasAction) {
      return [{ title: get(hasAction, 'title'), icon: 'error' }];
    }
    return [];
  })();

  if (title) {
    return (
      <Card className={classes.card} classes={{ root: classes.cardHeight }}>
        <CardActionArea onClick={() => onSelect(props)} classes={{ root: classes.cardHeight }}>
          <CardContent>
            <Column center fullHeight>
              {!!title && title}
              {!!subtitle && subtitle}
            </Column>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  }

  const hasImage = get(props, 'edition.image.thumb');

  return (
    <Card className={classes.card}>
      <CardActionArea onClick={() => onSelect(props)}>
        {actions.map((act) => (
          <Chip className={classes.chip} size="small" label={act.title} icon={<Icon>{act.icon}</Icon>} />
        ))}
        <CardMedia component="img" height="120" image={hasImage} alt="grey" />
        <CardContent height="100">
          <Text bold>{editionName}</Text>
          <BorderLinearProgress variant="determinate" value={compValue} />
          <div className={classes.flex}>
            <div>
              <Text type="label_small">completion</Text>
              <Text type="label_medium">{percentify(compValue)}</Text>
            </div>
            {isReview && (
              <div>
                <Text type="label_small">student</Text>
                <Text type="label_medium">{user}</Text>
              </div>
            )}
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    margin: `${theme.spacing(1)}px 0`,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[!isDark(theme) ? 300 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: (p) => (p.value === 100 ? theme.colors.success : theme.colors.blue),
  },
}))(LinearProgress);
